
export function loadProducts(layloadCallback) {
    const productsContainer = document.getElementById('productFilter-products');
    if (productsContainer) {
        const url = productsContainer.getAttribute("data-productsBoxUrl");
        if (!url) {
            return;
        }
    
        fetch(url)
            .then(response => {
                if (response?.status === 200) {
                    return response.json();
                }
            })
            .then(json => {
                if (json.products) {
                    productsContainer.innerHTML = json.products;
                    const skeleton = document.querySelector('.js-product-filter-skeleton');
                    if (skeleton) {
                        skeleton.style.display = 'none';
                    }
                    layloadCallback();
                }
            })
            .catch(e => console.error(e))
    }
}
